import {ComponentProps} from '@episerver/spa-core/EpiComponent';
import CellcomFiberAndWifiVideoBlockData from 'app/Models/Content/CellcomFiberAndWifiVideoBlockData';
import React from 'react';
import {getImageProps, getVideoLink} from 'app/utilities/ImageProps';
import {isMobile} from 'react-device-detect';
import BackgroundVideo from '../../Page/TVLobbyPage/BackgroundVideo';
import useFadeIn from 'app/Components/Shared/UseFadeIn';

const CellcomFiberAndWifiVideoBlock = ({data, context}: ComponentProps<CellcomFiberAndWifiVideoBlockData>) => {
  const videoUrl = data.mobileVideo.value || data.video.value ? getVideoLink(isMobile ? data.mobileVideo : data.video, context) : null;
  const imageUrl =
    data.mobileImage.expandedValue || data.image.expandedValue ? getImageProps(isMobile ? data.mobileImage : data.image, context) : null;

  const {fadeClass, ref} = useFadeIn();
  return (
    <div ref={ref} className={`CellcomFiberAndWifiVideoBlock ${fadeClass}`}>
      <BackgroundVideo videoUrl={videoUrl} fallbackImageProps={imageUrl} />
    </div>
  );
};

export default CellcomFiberAndWifiVideoBlock;
